/**
 * Addons <-> Vanga Bridge
 *
 * La section "SS - Product Addons" ajoute les produits complementaires coches
 * au formulaire produit sous forme de champs caches items[n][id] et
 * items[n][quantity], a cote du champ id du produit principal.
 *
 * Shopify traite ce formulaire correctement (produit principal + addons),
 * d'ou un panier natif qui fonctionne. Mais Vanga AI SmartCart intercepte le
 * clic "Ajouter au panier" et reconstruit sa propre requete : des qu'il trouve
 * des items[...] dans le formulaire, il n'envoie QUE ceux-la et abandonne le
 * produit principal (constate le 25/09/2026 sur Vanga upsellin-286).
 *
 * Ce script intercepte le clic AVANT Vanga (capture phase sur window), et
 * uniquement si un addon est coche et que Vanga est actif. Il envoie le
 * formulaire tel quel a /cart/add.js, exactement comme le panier natif, puis
 * ouvre le drawer Vanga via l'icone panier (clic que Vanga intercepte).
 *
 * Sans addon coche, ou sans Vanga, il ne fait rien : Vanga ou le panier natif
 * gardent la main.
 *
 * Non charge sur les produits perso : easify-vanga-bridge.js y intercepte deja
 * tous les clics et envoie le formulaire complet, addons compris.
 *
 * Version: 2026-09-25-r1
 */
(function () {
  'use strict';

  var SUBMIT_SELECTOR = 'product-form [type="submit"]';

  function isVangaActive() {
    // Vanga n'attache son shadow root qu'une fois reellement monte : sans lui,
    // son intercepteur de clic reste inerte et le panier natif fonctionne.
    var root = document.getElementById('vanga-smartcart');
    return !!(root && root.shadowRoot);
  }

  function hasCheckedAddons(form) {
    return !!form.querySelector('input[name^="items["]');
  }

  function setLoading(btn, loading) {
    var spinner = btn.querySelector('.loading-overlay__spinner');
    if (loading) {
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('loading');
      if (spinner) spinner.classList.remove('hidden');
    } else {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
    }
  }

  function getErrorWrapper(form) {
    var pf = form.closest('product-form') || form.parentElement;
    return (pf && pf.querySelector('.product-form__error-message-wrapper')) ||
      document.querySelector('.product-form__error-message-wrapper');
  }

  function showError(form, message) {
    var wrapper = getErrorWrapper(form);
    if (!wrapper) return;
    wrapper.removeAttribute('hidden');
    wrapper.style.removeProperty('display');
    var msg = wrapper.querySelector('.product-form__error-message');
    if (msg) msg.textContent = message;
  }

  function hideError(form) {
    var wrapper = getErrorWrapper(form);
    if (wrapper) wrapper.setAttribute('hidden', '');
  }

  function openCartDrawer() {
    setTimeout(function () {
      var cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) cartIcon.click();
    }, 250);
  }

  function handleClick(event) {
    var btn = event.target && event.target.closest(SUBMIT_SELECTOR);
    if (!btn) return;
    var productFormEl = btn.closest('product-form');
    var form = productFormEl && productFormEl.querySelector('form[action*="/cart/add"]');
    if (!form || !hasCheckedAddons(form) || !isVangaActive()) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (btn.getAttribute('aria-disabled') === 'true') return;

    hideError(form);
    setLoading(btn, true);

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: new FormData(form)
    })
      .then(function (resp) {
        return resp.json().catch(function () { return null; }).then(function (json) {
          return { ok: resp.ok, body: json };
        });
      })
      .then(function (result) {
        if (!result.ok || !result.body || (result.body.status && result.body.status !== 200)) {
          showError(form,
            (result.body && (result.body.description || result.body.message)) ||
            'Une erreur est survenue lors de l\'ajout au panier. Merci de reessayer.');
          return;
        }
        openCartDrawer();
      })
      .catch(function (err) {
        console.error('[addons-vanga-bridge] add to cart failed:', err);
        showError(form, 'Une erreur est survenue lors de l\'ajout au panier. Merci de reessayer.');
      })
      .then(function () {
        setLoading(btn, false);
      });
  }

  window.addEventListener('click', handleClick, { capture: true });
})();
